import React from "react";
import { TextField } from "@material-ui/core";
import { DatePicker } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import moment, { Moment } from "moment";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { changeReportDate, changeStartDate } from "redux/user/userActions";

const ReportDatePicker = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const value = useSelector((state: RootState) => state.user.reportDate);
  const startDate = useSelector((state: RootState) => state.user.startDate);
  const minDateString = useSelector(
    (state: RootState) => state.portfolioInformation.data?.SalkkuAloitettu
  );
  const minDate =
    minDateString !== undefined ? moment.utc(minDateString) : undefined;

  return (
    <DatePicker
      mask="_._.____"
      label={t("report_date")}
      openTo="year"
      views={["year", "month", "date"]}
      value={value}
      inputFormat="D.M.YYYY"
      onChange={(inputValue) => {
        if (moment(inputValue).isBefore(startDate)) {
          dispatch(
            changeStartDate(
              moment
                .utc(inputValue)
                .subtract(1, "months")
                .startOf("month")
                .toISOString()
            )
          );
        }
        dispatch(changeReportDate((inputValue as Moment).toISOString()));
      }}
      maxDate={moment().utc().subtract(1, "day")}
      minDate={minDate}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          helperText={undefined}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    />
  );
};

export default React.memo(ReportDatePicker);
